import React from 'react';

const Effect = ({currentEffects, updateCreatureEffects, effect, image}) => {
    const hasEffect = currentEffects.some(e => e === effect);

    return (
        <div className='effectWrapper'>
            <img className='effect'
                src={image}
                alt={effect}
                title={effect}
                style={{ 
                    opacity: hasEffect ? 0.3 : 1, 
                    outline: hasEffect ? '2px solid #ffffff' : '',
                    borderRadius: '100%',
                }}
                onClick={(event) => updateCreatureEffects(event, effect)}
            />
        </div>
    );
};

export default Effect;